export default __webpack_public_path__ + "3311d9e.png";